import Permissions from "../../constants/permissions";
import { DownloadPart } from "../../graphql/types";
import { DownloadAbandonButton } from "../AbandonButton";
import { ActionsMenu, CopyToClipboardButton } from "../ActionsMenu/ActionsMenu";
import { DownloadSamplesButton } from "../DownloadsComponents/DownloadSamplesButton";
import { IfPermission } from "../Permissions";

const canDownloadBeAbandoned = (status: string) => {
  return ["queued", "requested", "downloading", "unpacking", "retrying", "failed"].indexOf(status) > -1;
};

const DownloadsActionsMenu = ({
  bundleId,
  part,
  bundleStatus,
  bundleFinishedDate,
}: {
  bundleId: string;
  bundleStatus: string;
  part?: DownloadPart;
  bundleFinishedDate?: string | null;
}) => {
  return (
    <ActionsMenu>
      {({ closeModal }) => (
        <>
          <CopyToClipboardButton
            id={part?.id || bundleId}
            typeId={part?.id ? "Download Part ID" : "Download Bundle ID"}
            onClick={closeModal}
          />

          <IfPermission permission={Permissions.ManagePipelines}>
            <DownloadAbandonButton
              id={bundleId}
              withText
              onClick={closeModal}
              disabled={!canDownloadBeAbandoned(bundleStatus)}
              downloadStatus={bundleStatus}
            />
          </IfPermission>
          {part || bundleStatus != "completed" ? (
            <DownloadSamplesButton
              flow_source_id={part?.legacy_flow_source_id || ""}
              onClick={closeModal}
              finishedDate={bundleFinishedDate}
              downloadStatus={bundleStatus}
            />
          ) : null}
        </>
      )}
    </ActionsMenu>
  );
};

export { DownloadsActionsMenu };
